import { useEffect } from 'react';
import Footer from '@/components/Footer';
import logo from '@/assets/logo.png';
import LoginForm from './form';
import styles from './style/index.module.less';
import packageJson from '../../../package.json';

function Login() {
  useEffect(() => {
    document.body.setAttribute('arco-theme', 'light');
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <img src={logo} alt="" className={styles.logo} />
        <div className={styles['logo-text']}>{packageJson.productName}</div>
      </div>
      <div className={styles.content}>
        <div className={styles['content-inner']}>
          <LoginForm />
        </div>
        <div className={styles.footer}>
          <Footer />
        </div>
      </div>
    </div>
  );
}
Login.displayName = 'LoginPage';

export default Login;
